import {makeStyles, Theme} from '@material-ui/core';
import React, { cloneElement } from 'react';
import {Edit, required, SimpleForm, TextInput, Toolbar, SaveButton, DeleteButton, ReferenceInput, SelectInput} from 'react-admin';
import {Messages} from '../../consts/Messages';
import {CITIES, COUNTRIES, FIXED_COLUMN_CATEGORY} from '../../consts/Names';
import {Validators} from '../../consts/Validators';
import {useParams} from "react-router-dom";

const useStyles = makeStyles((theme: Theme) => ({
   form: {
      display: 'flex',
      flexDirection: 'column'
   },

   textFld: {
      width: '300px',
      marginTop: '1em'
   },
   imageFld: {
      display: 'flex',
      width: '300px'
   },
   toolBar:{
      flex: 1,
      display: "flex",
      "justify-content": "space-between"
   },
}));


const validateStock = [required(), Validators.minValue(3, Messages.MIN_VALUE)];
const validateHair = [required(), Validators.minValue(3, Messages.MIN_VALUE)];

const NameField = ({source, record={} , label = "", children, ...props}) => {   
   let disabled = (record as any).name === FIXED_COLUMN_CATEGORY;
   let validate = (record as any).name === FIXED_COLUMN_CATEGORY ? validateHair : validateStock;
   return cloneElement( children,  {disabled, validate, source, record,   props})
}
const EditToolbar = (props) => (
   <Toolbar {...props}  className={props.className}>
      <SaveButton submitOnEnter={false} variant="text" />
      {props.record.name !== FIXED_COLUMN_CATEGORY && <DeleteButton  undoable={false}/>}      
   </Toolbar>
);

export const CitiesEdit = (props) => {
   const {theme} = props;
   let basePath
   if (typeof props.basePath === 'undefined') {
      basePath = '';
   } else {
      basePath = props.basePath
   }
   const {id} = useParams()
   let ids = !props.id ? id : props.id
   const classes = useStyles(theme);
   return (<Edit {...props} id={ids} basePath={basePath} undoable={false} title="Edit city" >
      <SimpleForm toolbar={<EditToolbar {...props} className={classes.toolBar}/>}>
         <NameField source={CITIES.name}>
            <TextInput className={classes.textFld} label="Name" source={CITIES.name} />
         </NameField>
         <ReferenceInput className={classes.textFld} label="Country" source={CITIES.country_id} reference="countries" validate={[required()]}>
            <SelectInput source={COUNTRIES.id} />
         </ReferenceInput>
      </SimpleForm>
   </Edit>
)
}